import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import type { UserSecurityControl } from '../../types';
import type { UserSecurityControlApi } from '../user-security-control-api';

@injectable()
export class UserSecurityControlApiImpl extends PsHttpService implements UserSecurityControlApi {
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async getAmountsControl(): Promise<UserSecurityControl> {
        const result = await this.get<PatSnapSuccessResponseData<UserSecurityControl>>({
            url: '/user/amounts/control',
        });
        return result.data || {};
    }
}
